var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',{attrs:{"id":"calendar","title":"Calendar","back":"","searchable":true}},[_c('calendar-weekly',{ref:"weekly",attrs:{"date":_vm.$route.params.date}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }